module.exports = __webpack_public_path__ + "img/childseat_p.66568ade.png";